import { datadogRum } from '@datadog/browser-rum-slim';
import { CoreApplicationContext } from '@eventbrite/context-gen';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { gettext } from '@eventbrite/i18n';
import { middleware as analyticsMiddleware } from '@eventbrite/site-analytics';
import { StatsigOptions } from '@eventbrite/statsig';
import { $FixMe } from '@eventbrite/ts-utils';
import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { StringifyQuery } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { ConsumerHeader } from '../../components/ConsumerHeader';
import { StickyExperimentWrapper } from '../../containers/StickyExperimentWrapper';
import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { FeatureFlags } from '../../types';
import { FooterLinksShape, PlaceObject, Suggestions } from '../../types/index';
import '../app.scss';
import { BasePage } from '../base';
import './BrowsePage.scss';
import { CityBrowseBaseScreenContainer } from './containers';

type BrowsePageProps = RouteComponentProps & {
    footerLinks: FooterLinksShape;
    app_version?: string;
    app_name: string;
    env: CoreApplicationContext['env'];
    gaSettings: any;
    buckets: any;
    locations?: {
        places: PlaceObject[];
    };
    featureFlags: FeatureFlags;

    suggestions: Suggestions;
    http_referer: StringifyQuery;
    trending_search_cities?: string[][];
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        email?: string;
        isStaff?: boolean;
    };
    request: {
        path: string;
        session_id: string;
    };
    category_article_mapping: $FixMe;
    options: StatsigOptions;
};

const BrowsePage: FC<BrowsePageProps> = (props) => {
    const initialState = getInitialData(props);
    const store = createStore(
        reducer,
        initialState,
        applyMiddleware(thunk, analyticsMiddleware(props)),
    );
    const { env, user, featureFlags } = props;

    useEffectOnce(() => {
        if (getCurrentEnv(props) === EBEnvs.PROD) {
            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext('view.sub_app', 'browse'),
            );
        }
    }, []);

    const globalNavHeader = () => {
        return RenderGlobalNavOrUndefined({
            config: {
                env,
                user,
                searchBar: {
                    renderSearchBar: true,
                    desktopLabel: gettext('Search events'),
                    mobileLabel: gettext('Search'),
                },
            },
            featureFlag: featureFlags?.enableIaGlobalNav ?? false,
        });
    };

    return (
        <div>
            {/* TODO: EB-225864 sticky experiment cleanup */}
            <StickyExperimentWrapper>
                <Provider store={store}>
                    <BasePage
                        {...props}
                        structureHeader={ConsumerHeader}
                        overrideHeader={globalNavHeader()}
                    >
                        <div className="feed-browse-page">
                            {/* FIXME: fix mismatched types/props error https://eventbrite.atlassian.net/browse/EB-228487 */}
                            {/* eslint-disable-next-line */}
                            {/* @ts-ignore  */}
                            <CityBrowseBaseScreenContainer {...props} />
                        </div>
                    </BasePage>
                </Provider>
            </StickyExperimentWrapper>
        </div>
    );
};

export default BrowsePage;
